module.exports = __webpack_public_path__ + "img/WhatsApp-Logo-Icon@2x.6ce111ee.png";